import InlineAlert from '../Alert/InlineAlert'
import { FunctionComponent, ReactNode } from 'react'
import SimpleSortTable, { TableColumn, TableData } from '../SimpleSortTable/SimpleSortTable'
import Pagination from '../Pagination/Pagination'
import { PaginationMeta } from '../../../types/PaginationMeta'
import { SortDirection } from '../../../types/SortDirection'

interface ISortablePaginatedTableModule {
	data: Array<TableData>
	columns: Array<TableColumn>
	isLoading?: boolean
	error?: ReactNode
	emptyState?: ReactNode
	sort?: {
		key: string
		direction: SortDirection
	}
	onSortChange?: (key: string, direction: string) => void
	pagination?: PaginationMeta
	onPageChange?: (newPageNumber: number) => void
	rowClassName?: (row: TableData) => string
	additionalClass?: string
}

const SortablePaginatedTableModule: FunctionComponent<ISortablePaginatedTableModule> = ({
	data,
	columns,
	isLoading = false,
	error,
	emptyState,
	sort,
	onSortChange,
	pagination,
	onPageChange,
	rowClassName,
	additionalClass,
}) => {
	return (
		<div data-testid='sortable-paginated-table' className={additionalClass}>
			<SimpleSortTable
				data={data}
				columns={columns}
				defaultSorting={sort}
				onSortPress={onSortChange}
				isLoading={isLoading}
				rowClassName={rowClassName}
			/>
			{!isLoading && data.length === 0 && (
				<div
					data-testid='sortable-paginated-table-empty'
					className='rounded-lg bg-charcoal-700 p-4 mt-4 text-white text-center'
				>
					{emptyState ?? 'No results found.'}
				</div>
			)}
			{!isLoading && error && (
				<InlineAlert type='error' className='mt-4' data-testid='sortable-paginated-table-error'>					{error}
				</InlineAlert>
			)}
			{pagination && onPageChange && (
				<Pagination
					pagination={pagination}
					onPageChange={onPageChange}
					isLoading={isLoading}
				/>
			)}
		</div>
	)
}

export default SortablePaginatedTableModule
